import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'active-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex align-items-center">
      <div class="icon-container">
        <div class="icon"></div>
      </div>

      @if(rowData.memStatus == 2){
      <span class="active-text">Active</span>
      } @else {
      <span class="active-text">Inactive</span>
      }
    </div>
  `,
  styles: [
    `
      .active-text {
        font-size: 16px;
        font-weight: 500;
        font-family: var(--manrope);
        color: var(--text-secondary);
      }
      .icon-container {
        background-color: var(--text-secondary);
      }
      .icon {
        background-image: var(--tick);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
      }
    `,
  ],
})
export class ActiveCellComponent {
  @Input() rowData: any;
}
